/**
 * Legacy AnalyticsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.analyticsApi`) keep resolving.
 *
 * The actual AnalyticsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/analytics/analytics-api.service.ts
 */
angular.module("acme.common.service.analyticsApi", []);
